module.exports = __webpack_public_path__ + "static/media/undraw_package_arrived.1b82d7b5.png";